import '@babel/polyfill'
import Vue from 'vue'
import IES from './IES.vue'
import store from './store/index'
import marked from 'marked/lib/marked'

import VueAxios from './plugins/axios'
Vue.use(VueAxios)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    marked: function(input) {
      return marked(input)
    }
  }
})

new Vue({
  el: '#ies_app',
  store,
  components: {
    ies: IES
  }
})
